/**
 * 言語モーダルの制御
 */

export default class LanguageModal {
  constructor() {
    // 言語切り替えボタンを取得
    this.languageButton = document.querySelector('#js-header__list-item--bogo a');
    // モーダルを取得
    this.bogoModal = document.getElementById('bogo-modal');
  }

  /**
   * モーダルを表示する
   */
  showModal() {
    this.bogoModal.style.display = 'flex';
  }

  /**
   * モーダルを非表示にする
   */
  hideModal(event) {
    if (event.target === this.bogoModal) {
      this.bogoModal.style.display = 'none';
    }
  }

  /**
   * イベントを追加する
   */
  addEvent() {
    // 言語切り替えボタンのクリックイベント
    this.languageButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.showModal();
    });

    // モーダルの外側をクリックした際のイベント
    window.addEventListener('click', (e) => this.hideModal(e));
  }

  /**
   * 選択中の言語を最上部に持ってくる
   */
  arrangeLanguages() {
    // 選択中の言語を取得
    const currentLanguage = document.querySelector('.list-view li.current');
    // 日本語のliを取得
    const jaLanguage = this.bogoModal.querySelector('ul li.ja');
    // 日本語選択中であればなにもしない
    if (currentLanguage.classList.contains('ja')) return;
    // 英語選択中の場合
    if (currentLanguage.classList.contains('en')) {
      jaLanguage.classList.add('enSelected');
    }
    // タイ語選択中の場合
    if (currentLanguage.classList.contains('th')) {
      jaLanguage.classList.add('thSelected');
    }
  }

  /**
   * 初期化処理
   */
  init() {
    if (!this.languageButton || !this.bogoModal) return;
    this.addEvent();
    this.arrangeLanguages();
  }
}
